<template>
  <div :key="`app-rating-${id}`" class="app-rating">
    <fieldset class="rating">
      <input
        :id="`${id}-star5`"
        v-model="current"
        :name="`${id}-rating`"
        type="radio"
        value="5"
        @click="clicked"
      />
      <label :for="`${id}-star5`">5 stars</label>
      <input
        :id="`${id}-star4`"
        v-model="current"
        :name="`${id}-rating`"
        type="radio"
        value="4"
        @click="clicked"
      />
      <label :for="`${id}-star4`">4 stars</label>
      <input
        :id="`${id}-star3`"
        v-model="current"
        :name="`${id}-rating`"
        type="radio"
        value="3"
        @click="clicked"
      />
      <label :for="`${id}-star3`">3 stars</label>
      <input
        :id="`${id}-star2`"
        v-model="current"
        :name="`${id}-rating`"
        type="radio"
        value="2"
        @click="clicked"
      />
      <label :for="`${id}-star2`">2 stars</label>
      <input
        :id="`${id}-star1`"
        v-model="current"
        :name="`${id}-rating`"
        type="radio"
        value="1"
        @click="clicked"
      />
      <label :for="`${id}-star1`">1 star</label>
    </fieldset>
  </div>
</template>

<script type="text/babel">
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      current: null,
    };
  },

  watch: {
    id() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.current = this.rating ? Number(this.rating) : null;
    },

    clicked(event) {
      this.current = Number(this.current);

      if (Number(event.target.value) === this.current) {
        this.current = null;
        return this.$emit("rated", null);
      }

      this.current = Number(event.target.value);
      return this.$emit("rated", this.current);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.rating {
  float: left;
}

.rating label {
  margin-bottom: 0;
}

.rating:not(:checked) > input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}

.rating:not(:checked) > label {
  float: right;
  width: 1em;
  padding: 0 0.1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 150%;
  line-height: 1.2;
  color: #cbcbcb;
}

.rating:not(:checked) > label:before {
  content: "★ ";
}

.rating > input:checked ~ label {
  color: #36a9e1;
}

.rating:not(:checked) > label:hover,
.rating:not(:checked) > label:hover ~ label {
  color: #36a9e1;
}

.rating > input:checked + label:hover,
.rating > input:checked + label:hover ~ label,
.rating > input:checked ~ label:hover,
.rating > input:checked ~ label:hover ~ label,
.rating > label:hover ~ input:checked ~ label {
  color: #36a9e1;
}

.rating > label:active {
  position: relative;
  top: 2px;
  left: 2px;
}
</style>
